import { render, staticRenderFns } from "./DMATable.vue?vue&type=template&id=6c55a654&scoped=true"
import script from "./DMATable.vue?vue&type=script&lang=js"
export * from "./DMATable.vue?vue&type=script&lang=js"
import style0 from "./DMATable.vue?vue&type=style&index=0&id=6c55a654&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c55a654",
  null
  
)

export default component.exports